import useClassicGameActivity from './useClassicGameActivity.hook';
import { StyledClassicGameActivityWrapper } from './ClassicGameActivity.styled';
import DragAndMatchActivity from './DragAndMatchActivity/DragAndMatchActivity';
import ConceptRaceActivity from './ConceptRaceActivity/ConceptRaceActivity';
import CoverMenu from './CoverMenu/CoverMenu';
import AudioAutoPlayer from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayer';
import { useContext } from 'react';
import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import MemoryGameActivity from './MemoryGameActivity/MemoryGameActivity';
import AnimatedStars from '@/shared/StudentPage/StudentPageTopbar/GamificationScoreBoard/AnimatedStars/AnimatedStars';
import { GameControlBar } from '../GameControlBar/GameControlBar';

export default function ClassicGameActivity({
  activity,
  activityConf,
  taskActivityConf,
  taskProgressActions,
  demoMode,
  forceRestart,
}) {
  const fullscreenContext = useContext(FullscreenContext);
  const { state, actions } = useClassicGameActivity({
    activity,
    activityConf,
    taskProgressActions,
    forceRestart,
  });

  return (
    <StyledClassicGameActivityWrapper
      className={`${fullscreenContext.state.isFullscreen ? 'fullscreen' : ''}`}
      key={activity.id}
    >
      <div className="classic-game-activity">
        {
          {
            COVER: (
              <CoverMenu
                activity={activity}
                activityConf={state.activityConf}
                gameActions={{
                  setGameConf: actions.setGameConf,
                  startGame: actions.startGame,
                }}
                mode={taskActivityConf?.options?.mode}
              />
            ),
            GAME: {
              conceptRace: (
                <ConceptRaceActivity
                  key={'conceptRace' + state.gameKey}
                  activity={activity}
                  activityConf={state.activityConf}
                  taskProgressAPI={actions.taskProgressAPI}
                  demoMode={demoMode}
                  onFinishedActivity={actions.onFinishedActivity}
                />
              ),
              dragAndMatch: (
                <DragAndMatchActivity
                  key={'dragAndMatch' + state.gameKey}
                  activity={activity}
                  activityConf={state.activityConf}
                  taskProgressAPI={actions.taskProgressAPI}
                  demoMode={demoMode}
                  onFinishedActivity={actions.onFinishedActivity}
                />
              ),
              memoryGame: (
                <MemoryGameActivity
                  key={'dragAndMatch' + state.gameKey}
                  activity={activity}
                  activityConf={state.activityConf}
                  taskProgressAPI={actions.taskProgressAPI}
                  demoMode={demoMode}
                  onFinishedActivity={actions.onFinishedActivity}
                />
              ),
            }[state.activityConf.miniactivityType],
          }[state.screen]
        }
        <AnimatedStars originSelector=".last-correct" />
      </div>
      <GameControlBar
        state={state}
        actions={actions}
        activityConf={activityConf}
      />
      <AudioAutoPlayer />
    </StyledClassicGameActivityWrapper>
  );
}
